import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-validation-warning-dialog',
    templateUrl: './validation-warning-dialog.template.html',
})
export class ValidationWarningDialogComponent {
    @Input() isOpen = false;
    @Input() total = 0;
    @Input() failed = 0;
    @Output() confirm: EventEmitter<void> = new EventEmitter<void>();

    formattedJobPostingWord(count: number): string {
        return count === 1 ? 'job posting' : 'job postings';
    }
}
